import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import postCreateGiveaway from 'Api/brief-live/postCreateGiveaway';
import { useToast } from 'Store/toast';

import postCreateGiveawayRequest from './model/request/postCreateGiveawayRequest';

const usePostCreateGiveaway = (options) => {
  const navigate = useNavigate();
  const { onOpenToast } = useToast();
  return useMutation({
    mutationKey: ['post-create-giveaway'],
    mutationFn: async (formValues) => {
      const payload = postCreateGiveawayRequest(formValues);

      const result = await postCreateGiveaway(payload);

      return result;
    },
    onSuccess: () => {
      options?.onSuccess?.();
      navigate('/brief-live?tab=giveaway');
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: 'Giveaway berhasil tersimpan!',
        duration: 5,
        alwaysShow: false,
      });
    },
  });
};

export default usePostCreateGiveaway;
